import { render, staticRenderFns } from "./EditGeneralMemberView2.vue?vue&type=template&id=4e4af77c&scoped=true"
import script from "./EditGeneralMemberView2.vue?vue&type=script&lang=js"
export * from "./EditGeneralMemberView2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4af77c",
  null
  
)

export default component.exports